/* eslint-disable no-nested-ternary */
/* eslint-disable import/extensions */
/* eslint-disable import/no-unresolved */
/* eslint-disable no-debugger */
// import { useEffect, useState } from 'react';
// import { useSnackbar } from 'notistack5';
import PropTypes from 'prop-types';
import {
  Container,
  Paper,
  Stack,
  Typography,
  IconButton,
  Table,
  TableContainer,
  TableRow,
  TableHead,
  TableCell,
  TableBody,
  Button
} from '@material-ui/core';
import { Icon } from '@iconify/react';
import deleteIcon from '@iconify/icons-ic/round-delete-outline';
import addRule from '@iconify/icons-eva/plus-circle-outline';
import useSettings from 'src/hooks/useSettings';
import { useDispatch, useSelector } from 'react-redux';
import { COLLAPSIBLE_EXCLUSION_RULE_SET_LIST_HEAD } from 'src/constants/Dashboard';
import { useEffect, useState } from 'react';
import { findSegmentationData } from 'src/redux/slices/collection';
import { updateCampaignRuleSet } from 'src/redux/slices/campaignrules';
import editIcon from '@iconify/icons-eva/edit-fill';
import SegmentationRuleDialog from './SegmentationRuleDialog';
import SaveSegementRuleDialog from './SaveSegmentRuleDialog';

RuleList.propTypes = {
  selectedCampaignRuleId: PropTypes.number,
  segmentName: PropTypes.string,
  id: PropTypes.number
};

export default function RuleList({ id, selectedCampaignRuleId, segmentName }) {
  const { themeStretch } = useSettings();
  const dispatch = useDispatch();
  const { particularCampaignRuleData } = useSelector((state) => state.campaignrules);
  const { appliedRuleFile } = useSelector((state) => state.collection);
  const [segmentRules, setSegmentRules] = useState([]);

  useEffect(() => {
    console.log('segmentRules', segmentRules);
  }, [segmentRules]);

  useEffect(() => {
    setSegmentRules(
      particularCampaignRuleData[selectedCampaignRuleId]
        ? particularCampaignRuleData[selectedCampaignRuleId]?.rules
        : []
    );
  }, [selectedCampaignRuleId, particularCampaignRuleData]);

  let indexNumber = 0;

  const handleRuleDelete = (e, segmentRulesIndex) => {
    const tempSegmentRules = [...segmentRules];
    tempSegmentRules.splice(segmentRulesIndex, 1);
    setSegmentRules(tempSegmentRules);
  };

  const handleApplyClick = () => {
    const segmentationObj = {
      file: appliedRuleFile?.file,
      rules: segmentRules,
      segmentname: segmentName
    };
    dispatch(findSegmentationData(segmentationObj));
  };

  const updateCampaignRule = () => {
    dispatch(updateCampaignRuleSet(segmentRules, selectedCampaignRuleId));
    console.log('update campaign rule');
  };

  return (
    <>
      <Stack direction={{ xs: 'column', sm: 'row' }} spacing={{ xs: 3, sm: 2 }}>
        <Container maxWidth={themeStretch ? false : 'lg'}>
          <Paper>
            <Stack direction={{ xs: 'column', sm: 'column' }} spacing={{ xs: 3, sm: 2 }} justifyContent="space-evenly">
              <TableContainer>
                <Table
                  size="small"
                  aria-label="purchases"
                  //
                >
                  <TableHead>
                    <TableRow>
                      <TableCell
                        align="center"
                        colSpan={COLLAPSIBLE_EXCLUSION_RULE_SET_LIST_HEAD.length - 1}
                        sx={{
                          background: 'blanchedalmond',
                          boxShadow: 'inset -8px 0 0 blanchedalmond !important;',
                          fontSize: '16px'
                        }}
                      >
                        Rule List
                      </TableCell>
                      <TableCell
                        align="right"
                        sx={{ background: 'blanchedalmond', boxShadow: 'inset -8px 0 0 blanchedalmond !important;' }}
                        title="Add Rule"
                      >
                        <SegmentationRuleDialog
                          dialogTitle="Add Campaign Rule"
                          icon={addRule}
                          ruleId={selectedCampaignRuleId}
                          segmentName={segmentName}
                          setSegmentRules={setSegmentRules}
                        />
                      </TableCell>
                    </TableRow>
                    {/* Collapsable Table Head Row */}
                    <TableRow>
                      {COLLAPSIBLE_EXCLUSION_RULE_SET_LIST_HEAD.map((headData) => (
                        <TableCell
                          sx={{
                            boxShadow: headData.id === 'no' || headData.id === 'action' ? 'none !important' : ''
                          }}
                          align={headData.align ? headData.align : 'center'}
                          key={headData.key}
                        >
                          {headData.label}
                        </TableCell>
                      ))}
                    </TableRow>
                  </TableHead>
                  {segmentRules && segmentRules?.length !== 0 ? (
                    <TableBody sx={{ background: 'white' }}>
                      {segmentRules.length !== 0 &&
                        segmentRules?.map((nestedRowData, segmentRulesIndex) => (
                          <>
                            {/* findInnerRuleLength */}
                            {segmentRulesIndex !== 0 && nestedRowData.rules.length !== 0 && (
                              <TableRow key={segmentRulesIndex + 1}>
                                <TableCell
                                  component="th"
                                  scope="row"
                                  align="center"
                                  colSpan="5"
                                  sx={{ fontWeight: 'bolder' }}
                                >
                                  AND
                                </TableCell>
                              </TableRow>
                            )}
                            {nestedRowData?.rules.map((innerNestedRules, index) => {
                              indexNumber += 1;
                              return (
                                <>
                                  {index !== 0 && (
                                    <TableRow key={segmentRulesIndex} sx={{ background: 'aliceblue' }}>
                                      <TableCell
                                        component="th"
                                        scope="row"
                                        align="center"
                                        colSpan="5"
                                        sx={{ fontWeight: 'bolder' }}
                                      >
                                        OR
                                      </TableCell>
                                    </TableRow>
                                  )}
                                  <TableRow key={innerNestedRules.id} sx={{ background: 'aliceblue' }}>
                                    <TableCell>{indexNumber}</TableCell>
                                    <TableCell>{innerNestedRules.column_name}</TableCell>
                                    <TableCell align="center">{innerNestedRules.if_cell_value}</TableCell>
                                    <TableCell align="center">{innerNestedRules.value_or_text}</TableCell>
                                    <TableCell align="center">
                                      {index === 0 && (
                                        <>
                                          <SegmentationRuleDialog
                                            dialogTitle="Edit Campaign Rule"
                                            icon={editIcon}
                                            showbtnIcon
                                            parentRuleId={segmentRulesIndex}
                                            editId={{
                                              ruleId: nestedRowData.rule_collection_id,
                                              data: nestedRowData?.rules
                                            }}
                                            setSegmentRules={setSegmentRules}
                                          />
                                          <IconButton
                                            size="small"
                                            title="Delete"
                                            onClick={(e) => {
                                              handleRuleDelete(e, segmentRulesIndex);
                                            }}
                                          >
                                            <Icon icon={deleteIcon} />
                                          </IconButton>
                                        </>
                                      )}
                                    </TableCell>
                                  </TableRow>
                                </>
                              );
                            })}
                          </>
                        ))}
                    </TableBody>
                  ) : (
                    <TableRow>
                      <TableCell colSpan={COLLAPSIBLE_EXCLUSION_RULE_SET_LIST_HEAD.length + 1} align="center">
                        <Typography gutterBottom align="center" variant="subtitle1">
                          No Data Found
                        </Typography>
                      </TableCell>
                    </TableRow>
                  )}
                </Table>
              </TableContainer>
            </Stack>
          </Paper>
        </Container>
      </Stack>
      <Stack
        direction={{ xs: 'column', sm: 'row' }}
        spacing={{ xs: 3, sm: 2 }}
        justifyContent="space-between"
        alignItems="center"
        sx={{ marginBottom: '15px' }}
      >
        {segmentRules.length > 0 && (
          <>
            <div>
              <SaveSegementRuleDialog
                btnName="Save"
                title="Save New Campaign Rule"
                segmentRules={segmentRules}
                id={id}
              />

              {particularCampaignRuleData[selectedCampaignRuleId]?.rules && (
                <>
                  <Button variant="outlined" size="small" onClick={updateCampaignRule} sx={{ marginLeft: '10px' }}>
                    Update
                  </Button>
                </>
              )}
            </div>
          </>
        )}
        {segmentRules.length > 0 && (
          <Button variant="outlined" startIcon="" onClick={handleApplyClick}>
            Apply Rule
          </Button>
        )}
      </Stack>
    </>
  );
}
